// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__1LlZ_","ThumbZoom":"ChapterPlayer_ThumbZoom__39GJ_"};